'use client';
import { useState, useEffect } from 'react';

function useEdit(initialState) {
    const initialClone = JSON.parse(JSON.stringify(initialState));
    const [state, setState] = useState(initialClone);
    useEffect(() => {
        setState(initialClone);
    }, [initialState]);
    function revert() {
        setState(initialClone);
    }
    return [state, setState, revert];
}

export { useEdit };
